var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ADM/exit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4,5 L4,19 L16,19 L16,15.001 L14,15.001 L14,17.001 L6,17.001 L6,7.001 L14,7.001 L14,9.001 L16,9.001 L16,5 L4,5 Z M18,10 L11,10 L11,14 L18,14 L18,17.001 L24,12 L18,7.001 L18,10 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ADM-Tab-maillists-checkbox",
    transform: "translate(-16.000000, -833.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "components-/-app-panel/new"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ADM/exit",
    transform: "translate(16.000000, 833.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/exit.e97c873743a11233dff3a544c5d53430.svg";